import { Component, effect, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { UserPermissionsService } from "@kalmarenergi/data-access/iam/services/user-permission";
import { ApplicationLoaderComponent } from "@kalmarenergi/ui/loader/components/application-loader";
import { SkipToMainComponent } from "@kalmarenergi/ui/skip-to-main/skip-to-main.component";
import { ThemeStore } from "@kalmarenergi/util/store";

@Component({
  imports: [RouterOutlet, ApplicationLoaderComponent, SkipToMainComponent],
  selector: "portal-root",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  private userPermissionsService = inject(UserPermissionsService);
  private themeStore = inject(ThemeStore);

  readonly isSyncing = this.userPermissionsService.isSyncing;
  readonly currentTheme = this.themeStore.getTheme();

  currentThemeEffect = effect(() => {
    this.toggleThemeClassOnBody(this.currentTheme());
  });

  toggleThemeClassOnBody(theme: "system" | "light" | "dark") {
    const root = document.documentElement;
    const darkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    // Always reset color-scheme to support both
    root.style.setProperty("color-scheme", "light dark");

    // Remove previous listener to avoid duplicates
    darkMediaQuery.removeEventListener("change", () => {});

    if (theme === "dark") {
      root.style.setProperty("color-scheme", "dark");
      root.classList.add("tw-dark");
      return;
    }

    if (theme === "system") {
      root.style.setProperty("color-scheme", "light dark");
      root.classList.toggle("tw-dark", darkMediaQuery.matches);

      // Listen for system theme changes
      darkMediaQuery.addEventListener("change", (event) => {
        if (theme === "system") {
          root.classList.toggle("tw-dark", event.matches);
        }
      });
      return;
    }

    // theme === "light"
    root.style.setProperty("color-scheme", "light");
    root.classList.remove("tw-dark");
  }
}
